const React = require("react");
const gsap = require("gsap").default;
const ScrollTrigger = require("gsap/ScrollTrigger").default;
const CSSRulePlugin = require("gsap/CSSRulePlugin").default;
require("./src/sass/style.scss");

gsap.registerPlugin(ScrollTrigger, CSSRulePlugin);

exports.wrapPageElement = ({ element }) => {
  return <>{element}</>;
};
